module.exports = __webpack_public_path__ + "img/logo.d319a4a8.png";